import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Motion } from 'react-motion';
import merge from 'lodash/merge';

class KMotion extends Component {
  static getMergedStyles(styles, tween, values) {
    return merge({}, styles, tween(values));
  }

  render() {
    const { tween, children } = this.props;
    let { styles, start, end } = this.props;
    if (typeof styles === 'function') {
      styles = styles(this.props);
    }

    if (typeof start === 'function') {
      start = start(this.props);
    }

    if (typeof end === 'function') {
      end = end(this.props);
    }

    return (
      <Motion defaultStyle={start} style={end}>
        {tweenValues => {
          return React.cloneElement(React.Children.only(children), {
            styles: KMotion.getMergedStyles(styles, tween, tweenValues),
          });
        }}
      </Motion>
    );
  }
}

KMotion.propTypes = {
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  start: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  end: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  tween: PropTypes.func,
  children: PropTypes.element,
};

KMotion.defaultProps = {
  tween: () => {
    return {};
  },
  styles: {},
  start: () => {
    return {};
  },
  end: () => {
    return {};
  },
  children: <div />,
};

export default KMotion;
